import React from 'react';
import { IconToday, IconJournal, IconGoals, IconLibrary, IconSun } from './Icons';

const TABS = [
  { id: 'today', Icon: IconToday, label: 'Today' },
  { id: 'journal', Icon: IconJournal, label: 'Journal' },
  { id: 'goals', Icon: IconGoals, label: 'Intentions' },
  { id: 'foundations', Icon: IconSun, label: 'Core' },
  { id: 'library', Icon: IconLibrary, label: 'Library' },
];

export default function NavBar({ current, onNavigate }) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 430,
      background: '#FFFFFF', borderTop: '1px solid #F0EDE8',
      display: 'flex', justifyContent: 'space-around',
      padding: '10px 0 20px', zIndex: 1000,
    }}>
      {TABS.map(({ id, Icon, label }) => {
        const active = current === id;
        return (
          <button key={id} onClick={() => onNavigate(id)} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 10px', flex: 1 }}>
            <Icon size={22} color={active ? '#3A6A2A' : '#888888'} active={active} />
            <span style={{ fontSize: 9, color: active ? '#3A6A2A' : '#888888', letterSpacing: '.08em', textTransform: 'uppercase', fontWeight: active ? 800 : 600 }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
